
import React from 'react';
import cx from 'classnames';
import { Text, Link } from '../../../ui-kit';
import '../styles/_video-description.scss';













export default function VideoDescription(
{ title, description, cta, player, className })
{
  const ctaClick = () => {
    if (!cta || !cta.url) {return;}

    /* eslint-disable no-unused-expressions */
    cta.newWindowOnClick ?
    window.open(cta.url, '_blank').focus() :
    window.location.href = cta.url;
  };

  return (
    <div className={cx('video-description', className)}>
      <div className="video-container">
        {player}
      </div>
      <div className="description-container">
        <Text heading3>
          {title}
        </Text>
        <Text>
          {description}
        </Text>
        {cta &&

        <Link className="video-description-cta" onClick={() => ctaClick()}>
            {cta.text}
          </Link>}


      </div>
    </div>);

}